// Mobile navigation functionality
document.addEventListener('DOMContentLoaded', function() {
    // Enhanced active state detection for mobile navigation
    const currentPath = window.location.pathname;
    const queryParams = new URLSearchParams(window.location.search);
    const mobileNavItems = document.querySelectorAll('.mobile-nav-item');
    
    // Active state detection function
    function setActiveNavItem() {
        // First remove active state from all items
        mobileNavItems.forEach(item => {
            item.classList.remove('active');
        });
        
        // Find the correct active tab based on URL or context
        if (currentPath === '/store' || currentPath === '/') {
            // Home page
            const homeBtn = document.querySelector('[data-nav-type="home"]');
            if (homeBtn) homeBtn.classList.add('active');
        } else if (currentPath === '/myaccount') {
            // Profile page
            const accountBtn = document.querySelector('[data-nav-type="account"]');
            if (accountBtn) accountBtn.classList.add('active');
        } else if (currentPath === '/checkout' || currentPath === '/cart' || currentPath === '/shopping-bag') {
            // Cart/Bag page
            const bagBtn = document.querySelector('[data-nav-type="bag"]');
            if (bagBtn) bagBtn.classList.add('active');
        } else if (currentPath.includes('/shop') && queryParams.has('discounted')) {
            // Offers page
            const offersBtn = document.querySelector('[data-nav-type="offers"]');
            if (offersBtn) offersBtn.classList.add('active');
        } else if (currentPath.includes('/shop')) {
            // Set offers active if we're in shop but no other tab applies
            const offersBtn = document.querySelector('[data-nav-type="offers"]');
            if (offersBtn) offersBtn.classList.add('active');
        } else if (currentPath.includes('/about')) {
            // About page
            const menuBtn = document.querySelector('[data-nav-type="menu"]');
            if (menuBtn) menuBtn.classList.add('active');
        } else if (currentPath.includes('/contact')) {
            // Contact page
            const menuBtn = document.querySelector('[data-nav-type="menu"]');
            if (menuBtn) menuBtn.classList.add('active');
        }
    }
    
    // Initialize active state
    setActiveNavItem();
    
    // Check if mobile menu overlay already exists to prevent duplicates
    let mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    
    // Remove any existing overlay to prevent duplication on page changes
    if (mobileMenuOverlay) {
        mobileMenuOverlay.remove();
    }
    
    // Create a new mobile menu overlay
    mobileMenuOverlay = document.createElement('div');
    mobileMenuOverlay.classList.add('mobile-menu-overlay');
    
    // Style the mobile menu overlay
    mobileMenuOverlay.style.position = 'fixed';
    mobileMenuOverlay.style.top = '0';
    mobileMenuOverlay.style.left = '0';
    mobileMenuOverlay.style.right = '0';
    mobileMenuOverlay.style.bottom = '60px'; // Above bottom nav
    mobileMenuOverlay.style.backgroundColor = 'rgba(255, 255, 255, 0.98)';
    mobileMenuOverlay.style.zIndex = '1030'; // Higher than navbar
    mobileMenuOverlay.style.display = 'none';
    mobileMenuOverlay.style.overflowY = 'auto';
    mobileMenuOverlay.style.borderBottomLeftRadius = '15px';
    mobileMenuOverlay.style.borderBottomRightRadius = '15px';
    mobileMenuOverlay.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
    
    // Create a menu container
    const menuContainer = document.createElement('div');
    menuContainer.className = 'mobile-menu-container';
    menuContainer.style.padding = '60px 20px 20px'; // Reduced top padding since we removed header
    
    // Create a modern close button at the top
    const closeButton = document.createElement('button');
    closeButton.className = 'mobile-menu-close';
    closeButton.innerHTML = '<i class="bi bi-x-lg"></i>';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '15px';
    closeButton.style.right = '15px';
    closeButton.style.background = 'rgba(0,0,0,0.05)';
    closeButton.style.border = 'none';
    closeButton.style.borderRadius = '50%';
    closeButton.style.width = '40px';
    closeButton.style.height = '40px';
    closeButton.style.display = 'flex';
    closeButton.style.alignItems = 'center';
    closeButton.style.justifyContent = 'center';
    closeButton.style.fontSize = '20px';
    closeButton.style.cursor = 'pointer';
    closeButton.style.zIndex = '999';
    
    // Create main menu list
    const mainMenuList = document.createElement('ul');
    mainMenuList.className = 'mobile-main-menu';
    mainMenuList.style.listStyle = 'none';
    mainMenuList.style.padding = '0';
    mainMenuList.style.margin = '0';
    
    // Add menu items
    const menuItems = [
        { text: 'Shop All', url: '/shop', icon: 'bi-shop', hasDropdown: false },
        { text: 'Collections', url: '#', icon: 'bi-collection', hasDropdown: true, 
          dropdownItems: window.brandsList || [] },
        { text: 'Offers', url: '/shop?discounted=1&bundle=1', icon: 'bi-tag', hasDropdown: false },
        { text: 'About Us', url: '/about', icon: 'bi-info-circle', hasDropdown: false },
        { text: 'Contact Us', url: '/contact', icon: 'bi-envelope', hasDropdown: false }
    ];
    
    // Function to create menu items
    function createMenuItem(item) {
        const li = document.createElement('li');
        li.style.marginBottom = '15px';
        li.style.borderBottom = '1px solid rgba(0,0,0,0.05)';
        li.style.paddingBottom = '15px';
        
        const link = document.createElement('a');
        link.href = item.url;
        link.style.display = 'flex';
        link.style.alignItems = 'center';
        link.style.textDecoration = 'none';
        link.style.color = '#333';
        link.style.fontWeight = '500';
        link.style.fontSize = '16px';
        link.style.padding = '5px 0';
        
        // Highlight current page
        if (
            (item.url === '/shop' && currentPath === '/shop' && !queryParams.has('discounted') && !queryParams.has('brand')) ||
            (item.url === '/shop?discounted=1&bundle=1' && currentPath === '/shop' && queryParams.has('discounted')) ||
            (item.url === '/about' && currentPath.includes('/about')) ||
            (item.url === '/contact' && currentPath.includes('/contact'))
        ) {
            li.classList.add('current-page-item');
        }
        
        // Check if we're on a brand page to highlight the Collections item
        if (currentPath === '/shop' && queryParams.has('brand') && item.text === 'Collections') {
            li.classList.add('current-page-item');
        }
        
        const iconSpan = document.createElement('span');
        iconSpan.className = `bi ${item.icon}`;
        iconSpan.style.marginRight = '15px';
        iconSpan.style.fontSize = '20px';
        iconSpan.style.color = '#666';
        
        const textSpan = document.createElement('span');
        textSpan.textContent = item.text;
        
        link.appendChild(iconSpan);
        link.appendChild(textSpan);
        
        // If this menu item has a dropdown
        if (item.hasDropdown) {
            const arrowIcon = document.createElement('span');
            arrowIcon.className = 'bi bi-chevron-down';
            arrowIcon.style.marginLeft = 'auto';
            arrowIcon.style.fontSize = '16px';
            arrowIcon.style.transition = 'transform 0.3s ease';
            link.appendChild(arrowIcon);
            
            // Prevent default link action for dropdown toggles
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Toggle the arrow icon rotation
                if (arrowIcon.style.transform === 'rotate(180deg)') {
                    arrowIcon.style.transform = 'rotate(0)';
                } else {
                    arrowIcon.style.transform = 'rotate(180deg)';
                }
                
                // Toggle the dropdown content visibility
                const dropdown = this.nextElementSibling;
                const parentLi = this.parentElement; // Get the parent li element
                
                if (dropdown) {
                    if (dropdown.style.maxHeight && dropdown.style.maxHeight !== '0px') {
                        // Close dropdown
                        dropdown.style.maxHeight = '0px';
                        dropdown.style.opacity = '0';
                        dropdown.style.margin = '0';
                        dropdown.style.padding = '0';
                        
                        // Force redraw to ensure the transition is smooth
                        dropdown.offsetHeight;
                        
                        // After animation completes, completely hide the dropdown
                        setTimeout(() => {
                            dropdown.style.display = 'none';
                            dropdown.style.visibility = 'hidden';
                            
                            // Important: Reset parent li styles
                            parentLi.style.height = 'auto';
                            parentLi.style.paddingBottom = '15px';
                            
                            // Force layout recalculation to apply changes
                            document.body.offsetHeight;
                        }, 300);
                    } else {
                        // Show dropdown
                        dropdown.style.display = 'block';
                        dropdown.style.visibility = 'visible';
                        dropdown.style.padding = '0 0 0 35px';
                        dropdown.style.margin = '5px 0 0';
                        
                        // Force redraw before setting max-height for smooth animation
                        dropdown.offsetHeight;
                        
                        // Set height and opacity for animation
                        dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                        dropdown.style.opacity = '1';
                    }
                }
            });
            
            // Create dropdown list
            const dropdown = document.createElement('ul');
            dropdown.className = 'mobile-dropdown';
            dropdown.style.listStyle = 'none';
            dropdown.style.padding = '0';
            dropdown.style.margin = '0';
            dropdown.style.maxHeight = '0';
            dropdown.style.overflow = 'hidden';
            dropdown.style.transition = 'all 0.3s ease';
            dropdown.style.opacity = '0';
            dropdown.style.display = 'none';
            dropdown.style.visibility = 'hidden';
            
            // Add dropdown items
            if (Array.isArray(item.dropdownItems) && item.dropdownItems.length) {
                item.dropdownItems.forEach(dropdownItem => {
                    const dropdownLi = document.createElement('li');
                    dropdownLi.style.marginBottom = '10px';
                    
                    const dropdownLink = document.createElement('a');
                    dropdownLink.href = `/shop?brand=${encodeURIComponent(dropdownItem.brand)}`;
                    dropdownLink.style.display = 'block';
                    dropdownLink.style.textDecoration = 'none';
                    dropdownLink.style.color = '#666';
                    dropdownLink.style.fontSize = '14px';
                    dropdownLink.style.padding = '5px 0';
                    dropdownLink.textContent = dropdownItem.brand;
                    
                    dropdownLi.appendChild(dropdownLink);
                    dropdown.appendChild(dropdownLi);
                });
            } else {
                // If no brands available yet, create a fallback message
                const noBrandsMessage = document.createElement('li');
                noBrandsMessage.textContent = 'No collections available';
                noBrandsMessage.style.color = '#999';
                noBrandsMessage.style.fontSize = '14px';
                noBrandsMessage.style.padding = '5px 0';
                dropdown.appendChild(noBrandsMessage);
            }
            
            li.appendChild(link);
            li.appendChild(dropdown);
        } else {
            li.appendChild(link);
        }
        
        return li;
    }
    
    // Add all menu items to the list
    menuItems.forEach(item => {
        mainMenuList.appendChild(createMenuItem(item));
    });
    
    // Assemble the menu
    menuContainer.appendChild(closeButton);
    menuContainer.appendChild(mainMenuList);
    mobileMenuOverlay.appendChild(menuContainer);
    
    // Add to the DOM
    document.body.appendChild(mobileMenuOverlay);
    
    // Mobile menu toggle handler - fixed to find toggle across all pages
    const menuToggles = document.querySelectorAll('.js-menu-toggle');
    
    if (menuToggles.length > 0) {
        // Add event listeners to all menu toggles found
        menuToggles.forEach(menuToggle => {
            // Toggle menu visibility
            menuToggle.addEventListener('click', function(e) {
                e.preventDefault();
                toggleMobileMenu();
            });
        });
        
        // Handle close button click
        closeButton.addEventListener('click', function() {
            toggleMobileMenu();
        });
        
        // Close when clicking outside the menu content (on the overlay)
        mobileMenuOverlay.addEventListener('click', function(e) {
            if (e.target === mobileMenuOverlay) {
                toggleMobileMenu();
            }
        });
    }
    
    // Cart indicator sync
    function syncCartCount() {
        const desktopCart = document.getElementById('cart-count');
        const mobileCart = document.getElementById('mobile-cart-count');
        const desktopIndicator = document.getElementById('cart-indicator');
        const mobileIndicator = document.getElementById('mobile-cart-indicator');
        
        if (desktopCart && mobileCart) {
            const count = desktopCart.textContent;
            mobileCart.textContent = count;
            
            if (count && parseInt(count) > 0) {
                if (desktopIndicator) desktopIndicator.style.display = 'inline-block';
                if (mobileIndicator) mobileIndicator.style.display = 'inline-block';
                
                // If cart has items, make sure bag icon is focused
                if (currentPath === '/checkout') {
                    setActiveNavItem();
                }
            } else {
                if (desktopIndicator) desktopIndicator.style.display = 'none';
                if (mobileIndicator) mobileIndicator.style.display = 'none';
            }
        }
    }
    
    // Run once on load
    syncCartCount();
    
    // Set up a MutationObserver to watch for changes in the cart count
    const cartCount = document.getElementById('cart-count');
    if (cartCount) {
        const observer = new MutationObserver(function() {
            syncCartCount();
        });
        observer.observe(cartCount, { childList: true, subtree: true, characterData: true });
    }
    
    // Mobile footer accordion functionality
    const footerAccordionBtns = document.querySelectorAll('.footer-accordion-btn');
    footerAccordionBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            // Toggle active class on the button
            this.classList.toggle('active');
            
            // Get the content associated with this button
            const content = this.nextElementSibling;
            
            // Toggle active class on the content
            if (content.classList.contains('active')) {
                content.classList.remove('active');
            } else {
                // Close any open accordions first
                document.querySelectorAll('.footer-accordion-content.active').forEach(openContent => {
                    if (openContent !== content) {
                        openContent.classList.remove('active');
                        // Find the associated button and remove active class
                        const openBtn = openContent.previousElementSibling;
                        if (openBtn) {
                            openBtn.classList.remove('active');
                        }
                    }
                });
                
                // Open this accordion
                content.classList.add('active');
            }
        });
    });

    // Function to toggle mobile menu visibility
    function toggleMobileMenu() {
        if (mobileMenuOverlay.style.display === 'none') {
            // Show menu
            mobileMenuOverlay.style.display = 'block';
            mobileMenuOverlay.style.top = '0'; // Ensure top is always 0
            document.body.style.overflow = 'hidden';
            document.body.classList.add('menu-open');
            document.documentElement.classList.add('menu-open'); // Add class to HTML element too
            
            // Make sure menu is in correct position for all page types
            setTimeout(() => {
                // Force reflow to apply styles properly
                mobileMenuOverlay.style.opacity = '0.99';
                setTimeout(() => {
                    mobileMenuOverlay.style.opacity = '1';
                }, 10);
            }, 0);
            
            document.querySelector('.js-menu-toggle').classList.add('active');
        } else {
            // Hide menu
            mobileMenuOverlay.style.display = 'none';
            document.body.style.overflow = '';
            document.body.classList.remove('menu-open');
            document.documentElement.classList.remove('menu-open'); // Remove class from HTML element too
            document.querySelector('.js-menu-toggle').classList.remove('active');
        }
    }

    // Function to sync cart indicators between mobile and desktop
    function syncCartIndicators() {
        // Get cart items from session storage
        const cartItems = sessionStorage.getItem('temp_cart_items');
        const cartCount = cartItems ? JSON.parse(cartItems).length : 0;
        
        // Update desktop indicators
        const desktopIndicator = document.getElementById('cart-indicator');
        const desktopCount = document.getElementById('cart-count');
        
        if (desktopIndicator && desktopCount) {
            if (cartCount > 0) {
                desktopIndicator.style.display = 'inline-block';
                desktopCount.textContent = cartCount;
            } else {
                desktopIndicator.style.display = 'none';
            }
        }
        
        // Update mobile indicators
        const mobileIndicator = document.getElementById('mobile-cart-indicator');
        const mobileCount = document.getElementById('mobile-cart-count');
        
        if (mobileIndicator && mobileCount) {
            if (cartCount > 0) {
                mobileIndicator.style.display = 'inline-block';
                mobileCount.textContent = cartCount;
            } else {
                mobileIndicator.style.display = 'none';
            }
        }
    }
    
    // Run the sync function when the page loads
    syncCartIndicators();
    
    // Set up a periodic check to keep indicators in sync
    setInterval(syncCartIndicators, 2000);

    // Add logout handler
    const logoutLinks = document.querySelectorAll('.logout-link');
    logoutLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            frappe.call({
                method: 'noctis_ecommerce.api.user_utils.customer_logout',
                callback: function(response) {
                    if (response.message && response.message.success) {
                        // Show success message
                        frappe.show_alert({
                            message: 'Logged out successfully. Redirecting...',
                            indicator: 'green'
                        });
                        
                        // Clear any local storage
                        localStorage.removeItem('temp_cart_items');
                        localStorage.removeItem('temp_cart_id');
                        
                        // Redirect after a short delay
                        setTimeout(function() {
                            window.location.href = response.message.redirect_to || '/store';
                        }, 1000);
                    } else {
                        // Show error message
                        frappe.show_alert({
                            message: response.message.message || 'Error during logout',
                            indicator: 'red'
                        });
                    }
                },
                error: function() {
                    // Fallback to standard logout in case of error
                    window.location.href = '/api/method/logout';
                }
            });
        });
    });
});